var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "formRef",
      staticClass: "company-info_form",
      attrs: {
        model: _vm.form,
        "label-width": "120px",
        "label-position": _vm.getIsMobile ? "top" : "right",
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "接受人" } },
                [
                  _c("el-input", {
                    ref: "inputRef",
                    attrs: {
                      placeholder: "请选择接受人",
                      type: "text",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "部门" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入部门", type: "text" },
                    model: {
                      value: _vm.form.bumen,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bumen", $$v)
                      },
                      expression: "form.bumen",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "电话" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入电话", type: "text" },
                    model: {
                      value: _vm.form.lxrtel,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "lxrtel", $$v)
                      },
                      expression: "form.lxrtel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号", type: "text" },
                    model: {
                      value: _vm.form.lxrphone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "lxrphone", $$v)
                      },
                      expression: "form.lxrphone",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "传真" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入传真", type: "text" },
                    model: {
                      value: _vm.form.lxrmax,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "lxrmax", $$v)
                      },
                      expression: "form.lxrmax",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入邮箱", type: "text" },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }